import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import ExternalLink from 'core/components/ExternalLink'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Text from 'core/elements/Text'
import type Theme from 'core/themes/model'

type Props = {
  url: string
  text?: string
  className?: string
  [key: string]: any
}

const LearnMoreLink = ({ url, text = 'Learn more...', className, ...rest }: Props) => {
  const classes = useStyles()

  return (
    <ExternalLink className={clsx(classes.learnMore, className)} url={url} {...rest}>
      <Text variant="caption1">
        {text} <FontAwesomeIcon size="small">external-link</FontAwesomeIcon>
      </Text>
    </ExternalLink>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  learnMore: {
    cursor: 'pointer',

    '& span': {
      color: theme.palette.blue[900],
    },
    '& i': {
      color: theme.palette.blue[900],
    },
  },
}))

export default LearnMoreLink
